import { Component,Input } from '@angular/core';
import { UiElementType } from 'classes/UIElementType';
import { NodeTypes, MetaDataDto } from "dto/MetadataDto";

@Component({
  selector: 'node-type',
  templateUrl: './node-type.component.html'
})
export class NodeTypeComponent {
  UiElementType = UiElementType;
  NodeTypes = NodeTypes;
  @Input() template:MetaDataDto;

  constructor() { }

}



// WEBPACK FOOTER //
// C:/git/flowdesigner/src/app/node-type/node-type.component.ts